module.exports = __webpack_public_path__ + "445d79be749cd7f3687de919718486e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/picture/Chinese.jpg
// module id = 401
// module chunks = 0